module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/general/shield-disabled-de674548fd6189a934a5efb66598ede7.svg";